import { render, staticRenderFns } from "./CampaignTransaction.vue?vue&type=template&id=6a475306"
import script from "./CampaignTransaction.vue?vue&type=script&lang=js"
export * from "./CampaignTransaction.vue?vue&type=script&lang=js"
import style0 from "./CampaignTransaction.vue?vue&type=style&index=0&id=6a475306&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports